import React from 'react';
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  // useTheme
} from '@material-ui/core';

const Sales = ({ className, data, labels, title,subtitle, ...rest }) => {
  // const theme = useTheme();

  const state = {
    options: {
      chart: {
        id: 'Bar-Graph'
      },
      xaxis: {
        categories: labels
      },
      // colors: colors,
      subtitle: {
        text: `Data Source:` + `${subtitle}`,
        align: 'right',
        style: {
          fontSize: "11px",
          color: '#666'
        }
      },
    },
    series: [
      {
        name: 'This Year',
        data: data
      }
    ]
  };

  return (
    <Card className={className} {...rest}>
      <CardHeader title={title} />
      <Divider />
      <CardContent>
        <Chart options={state.options} series={state.series} type="bar" />
      </CardContent>
    </Card>
  );
};

Sales.propTypes = {
  className: PropTypes.string
};

export default Sales;
